<template>
  <footer v-if="hasSelectedItems" class="search__footer">
    <a class="search__clear-link" href="#" @click="handleClear($event)">
      <icon link type="times"></icon>
      Rensa alla val
    </a>
  </footer>
</template>

<script>
import Icon from '@/components/Icon'
import { CLEAR_FROM_QUERY } from '@/store/actionTypes'

export default {
  name: 'SearchClear',

  components: {
    Icon
  },

  props: {
    queryType: {
      required: true,
      type: String
    }
  },

  computed: {
    hasSelectedItems() {
      return this.$store.getters.getQueryType(this.queryType) > 0
    }
  },

  methods: {
    handleClear(event) {
      event.preventDefault()
      event.stopPropagation()

      window.eventBus.$emit('clearLocal', this.queryType)
      this.$store.commit(CLEAR_FROM_QUERY, this.queryType)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search__footer {
  padding: 20px;

  @media (--bp-desktop) {
    margin-top: 40px;
    padding: 0;
  }
}

.search__clear-link {
  color: var(--color-matisse);
  display: flex;
  font-size: 16px;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchClear.vue